var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareModalIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 48 48",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    color: "white",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "share"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m35.274 15.838h-4.094c-.828 0-1.5.671-1.5 1.5s.672 1.5 1.5 1.5h4.095c.827 0 1.5.673 1.5 1.5v19.616c0 .827-.673 1.5-1.5 1.5h-22.549c-.827 0-1.5-.673-1.5-1.5v-19.616c0-.827.673-1.5 1.5-1.5h4.095c.829 0 1.5-.671 1.5-1.5s-.671-1.5-1.5-1.5h-4.095c-2.481 0-4.5 2.019-4.5 4.5v19.616c0 2.481 2.019 4.5 4.5 4.5h22.549c2.481 0 4.5-2.019 4.5-4.5v-19.616c-.001-2.482-2.019-4.5-4.501-4.5zm-16.867-3.028 4.143-4.143v19.748c0 .828.671 1.5 1.5 1.5s1.5-.672 1.5-1.5v-19.748l4.143 4.143c.293.293.677.439 1.061.439s.768-.146 1.061-.439c.586-.585.586-1.536 0-2.121l-6.703-6.704c-.587-.586-1.536-.586-2.122 0l-6.704 6.704c-.586.585-.586 1.536 0 2.121.586.586 1.535.586 2.121 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareModalIcon);
export default __webpack_public_path__ + "static/media/ShareModalIcon.fd112bcd3492013a6808e43410fd88a0.svg";
export { ForwardRef as ReactComponent };